import { db } from "@/firebase/config";

export const addContent = async (chapterID, content) => {
    try {
        let result = await contentCollectionRef(chapterID)
            .add(content);
        return result;
    } catch (exception) {
        return null;
    }
};

export const getContentByID = (chapterID, contentID) => db.doc(`chapters/${chapterID}/contents/${contentID}`);

export const updateContentOrder = async (chapterID, contentIDs) => {
    try {
        let result = await db.doc(`chapters/${chapterID}`)
            .update({ contentOrder: contentIDs });
        return result;
    } catch (exception) {
        return null;
    }
};

export const deleteContent = async (chapterID, contentID) => {
    try {
        getContentByID(chapterID, contentID).delete()
        return true;
    } catch(exception) {
        return false;
    }
}

export const contentCollectionRef = (chapterID) => db.collection(`chapters/${chapterID}/contents`);

export const updateContent = async (chapterID, contentID, newContent) => {
    try {
        let result = await contentCollectionRef(chapterID).doc(contentID).update(newContent);
        return result;
    } catch (exception) {
        return null;
    }
}
